/** Display sizes for tightly framed animation assets, by their role in the UI. */
export const LOTTIE_SIZES = {
  emptyState: 144,
  // The search illustration includes a wide ring of particles around its subject.
  // This keeps the magnifying glass itself close to the loading book's visual size.
  searchEmptyState: 224,
  loading: 120,
  sidebar: 96,
  sidebarSearch: 120,
  dialog: { xs: 56, sm: 64 },
} as const;

/** A square layout slot; artwork proportions never determine its dimensions. */
export const lottieFrameStyle = <Size extends number | { xs: number; sm: number }>(size: Size) => ({
  width: size,
  height: size,
  aspectRatio: '1 / 1',
  boxSizing: 'border-box',
  padding: 0,
  flexShrink: 0,
  display: 'grid',
  gridTemplateColumns: 'minmax(0, 1fr)',
  gridTemplateRows: 'minmax(0, 1fr)',
} as const);

export const lottieContentStyle = {
  display: 'block', width: '100%', height: '100%', minWidth: 0, minHeight: 0,
} as const;

/** Fit the trimmed asset into its square slot without stretching or cropping. */
export const lottieRendererSettings = { preserveAspectRatio: 'xMidYMid meet' } as const;
